import * as passwordReset from './passwordReset.js'
import * as verification from './verification.js'

export default {
  passwordReset,
  verification
}
